import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { ExclamationTriangleSolidIcon, CheckSolidIcon, InfoSolidIcon } from '@fiverr-private/icons';
import { Message, MessageType } from '@fiverr-private/layout-types';
import './style.scss';

/**
 * All possible message type.
 */
export const MESSAGE_TYPES: Record<string, MessageType> = {
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
} as const;

export const iconByType = {
    [MESSAGE_TYPES.ERROR]: ExclamationTriangleSolidIcon,
    [MESSAGE_TYPES.INFO]: InfoSolidIcon,
    [MESSAGE_TYPES.SUCCESS]: CheckSolidIcon,
    [MESSAGE_TYPES.WARNING]: ExclamationTriangleSolidIcon,
};

/**
 * Display a message.
 */
const MessageComponent: React.FC<Message> = ({ type, value }) => (
    <div className={`layout-message ${type}`}>
        <Icon className="icon" size={16}>
            {iconByType[type]}
        </Icon>
        <div dangerouslySetInnerHTML={{ __html: value }} />
    </div>
);

export default MessageComponent;
